const qaThreads = {
  en: {
    statusAnswered: 'Answered',
    statusUnanswered: 'Unanswered',
    statusClosed: 'Closed',
    anonymous: 'Anonymous',
    replyCount: '{count} reply',
    replyCount_plural: '{count} replies',
    backToQA: 'Back to Q&A',
    openThread: 'Open thread: {title}',
    sectionQuestion: 'Question',
    repliesSectionTitle: 'Replies ({count})',
    noRepliesYet: 'No replies yet. Be the first to respond!',
    teacherBadge: 'Teacher',
    postAReply: 'Post a reply',
    replyPlaceholder: 'Type your response here...',
    charCount: '{count}/{max}',
    cancel: 'Cancel',
    postReply: 'Post reply',
    updatesEvery30Seconds: 'Updates every 30 seconds',
    liveBadge: 'Live',
    failedToPostReply: 'Failed to post reply',
    failedToLoadThread: 'Could not load the latest thread data.',
    lessonFilterAria: 'Filter by lesson',
    filterLessonLabel: 'Lesson',
    filterSortLabel: 'Sort by',
    filterStatusLabel: 'Status',
    lessonFilterAll: 'All lessons',
    loadingLessons: 'Loading lessons...',
    lessonsLoadFailed: 'Failed to load lessons',
    noLessonsTitle: 'No lessons yet',
    noLessonsDesc: 'Add a lesson to this course to start collecting student questions.',
    pageTitle: 'Lesson Q&A',
    parent: 'Course',
    backToCourse: 'Back to the course',
    updated: 'Updated {time}',
    refresh: 'Refresh',
    refreshTitle: 'Refresh threads',
    loading: 'Loading Q&A threads...',
    errorLoad: 'Failed to load Q&A threads',
    accessDenied: "You don't have access to view this course's Q&A.",
    searchPlaceholder: 'Search questions...',
    sortLatest: 'Latest',
    sortPopular: 'Most replies',
    sortUnanswered: 'Unanswered',
    filterAllThreads: 'All threads',
    filterAnswered: 'Answered',
    filterUnanswered: 'Unanswered',
    emptyTitle: 'No questions yet',
    emptyDesc: 'When students post questions about the course, they will appear here for you to answer.',
    retry: 'Retry',
    sortAria: 'Sort threads',
    statusFilterAria: 'Filter by status',
    noMatchTitle: 'No matching questions',
    noMatchDesc: 'Try another search or clear the filters.',
    clearFilters: 'Clear filters',
  },
  ru: {
    statusAnswered: 'Отвечено',
    statusUnanswered: 'Без ответа',
    statusClosed: 'Закрыто',
    anonymous: 'Аноним',
    replyCount: '{count} ответ',
    replyCount_few: '{count} ответа',
    replyCount_plural: '{count} ответов',
    backToQA: 'Назад к вопросам и ответам',
    openThread: 'Открыть тему: {title}',
    sectionQuestion: 'Вопрос',
    repliesSectionTitle: 'Ответы ({count})',
    noRepliesYet: 'Пока нет ответов. Будьте первым!',
    teacherBadge: 'Преподаватель',
    postAReply: 'Оставить ответ',
    replyPlaceholder: 'Введите ваш ответ...',
    charCount: '{count}/{max}',
    cancel: 'Отмена',
    postReply: 'Отправить ответ',
    updatesEvery30Seconds: 'Обновление каждые 30 секунд',
    liveBadge: 'Автообновление',
    failedToPostReply: 'Не удалось отправить ответ',
    failedToLoadThread: 'Не удалось загрузить актуальные данные темы.',
    lessonFilterAria: 'Фильтр по уроку',
    filterLessonLabel: 'Урок',
    filterSortLabel: 'Сортировка',
    filterStatusLabel: 'Статус',
    lessonFilterAll: 'Все уроки',
    loadingLessons: 'Загрузка уроков...',
    lessonsLoadFailed: 'Не удалось загрузить уроки',
    noLessonsTitle: 'Пока нет уроков',
    noLessonsDesc: 'Добавьте урок в этот курс, чтобы начать собирать вопросы студентов.',
    pageTitle: 'Вопросы и ответы по урокам',
    parent: 'Курс',
    backToCourse: 'Назад к курсу',
    updated: 'Обновлено {time}',
    refresh: 'Обновить',
    refreshTitle: 'Обновить темы',
    loading: 'Загрузка тем вопросов и ответов...',
    errorLoad: 'Не удалось загрузить темы вопросов и ответов',
    accessDenied: 'У вас нет доступа к разделу вопросов и ответов этого курса.',
    searchPlaceholder: 'Поиск вопросов...',
    sortLatest: 'Новые',
    sortPopular: 'Больше ответов',
    sortUnanswered: 'Без ответа',
    filterAllThreads: 'Все темы',
    filterAnswered: 'С ответом',
    filterUnanswered: 'Без ответа',
    emptyTitle: 'Пока нет вопросов',
    emptyDesc: 'Когда студенты будут задавать вопросы по курсу, они появятся здесь, и вы сможете на них ответить.',
    retry: 'Повторить',
    sortAria: 'Сортировка обсуждений',
    statusFilterAria: 'Фильтр по статусу',
    noMatchTitle: 'Подходящих вопросов нет',
    noMatchDesc: 'Измените запрос или сбросьте фильтры.',
    clearFilters: 'Сбросить фильтры',
  },
  uz: {
    statusAnswered: 'Javob berilgan',
    statusUnanswered: 'Javobsiz',
    statusClosed: 'Yopilgan',
    anonymous: 'Anonim',
    replyCount: '{count} ta javob',
    replyCount_plural: '{count} ta javob',
    backToQA: 'Savol-javobga qaytish',
    openThread: 'Mavzuni ochish: {title}',
    sectionQuestion: 'Savol',
    repliesSectionTitle: 'Javoblar ({count})',
    noRepliesYet: 'Hali javoblar yo\'q. Birinchi bo\'lib javob bering!',
    teacherBadge: 'O\'qituvchi',
    postAReply: 'Javob yozish',
    replyPlaceholder: 'Javobingizni shu yerga yozing...',
    charCount: '{count}/{max}',
    cancel: 'Bekor qilish',
    postReply: 'Javobni yuborish',
    updatesEvery30Seconds: 'Har 30 soniyada yangilanadi',
    liveBadge: 'Jonli',
    failedToPostReply: 'Javobni yuborib bo\'lmadi',
    failedToLoadThread: "Mavzuning so'nggi ma'lumotlarini yuklab bo'lmadi.",
    lessonFilterAria: 'Dars bo\'yicha filtr',
    filterLessonLabel: 'Dars',
    filterSortLabel: 'Saralash',
    filterStatusLabel: 'Holat',
    lessonFilterAll: 'Barcha darslar',
    loadingLessons: 'Darslar yuklanmoqda...',
    lessonsLoadFailed: 'Darslarni yuklab bo\'lmadi',
    noLessonsTitle: 'Hali darslar yo\'q',
    noLessonsDesc: "O'quvchilar savollarini yig'ishni boshlash uchun ushbu kursga dars qo'shing.",
    pageTitle: 'Darslar bo\'yicha savol-javob',
    parent: 'Kurs',
    backToCourse: 'Kursga qaytish',
    updated: 'Yangilandi {time}',
    refresh: 'Yangilash',
    refreshTitle: 'Mavzularni yangilash',
    loading: 'Savol-javob mavzulari yuklanmoqda...',
    errorLoad: 'Savol-javob mavzularini yuklab bo\'lmadi',
    accessDenied: 'Sizda ushbu kursning savol-javob bo\'limini ko\'rish huquqi yo\'q.',
    searchPlaceholder: 'Savollarni qidirish...',
    sortLatest: 'Yangi',
    sortPopular: 'Ko\'p javob olgan',
    sortUnanswered: 'Javobsiz',
    filterAllThreads: 'Barcha mavzular',
    filterAnswered: 'Javob berilgan',
    filterUnanswered: 'Javobsiz',
    emptyTitle: 'Hali savollar yo\'q',
    emptyDesc: "O'quvchilar kurs bo'yicha savol berganda, ular shu yerda paydo bo'ladi va siz javob bera olasiz.",
    retry: 'Qayta urinish',
    sortAria: 'Mavzularni saralash',
    statusFilterAria: "Holat bo'yicha filtr",
    noMatchTitle: 'Mos savollar topilmadi',
    noMatchDesc: "Boshqa so'z bilan qidiring yoki filtrlarni tozalang.",
    clearFilters: 'Filtrlarni tozalash',
  },
};

export default qaThreads;
